import { ToastContainer } from 'react-toastify';
import styled, { css } from 'styled-components';

const baseToastStyle = css`
  font-family: inherit;
  border-radius: 30px;
  color: ${({ theme }) => theme.colors.commonWhiteMain};
`;

export const toastWidthAutoClassName = 'width-auto';

export const StyledToastContainer = styled(ToastContainer)`
  // The container does the positioning based on fixed position of the container itself.
  // This won't work in a 100% width container. But we want to have control over the
  // toasts width, therefore using fit-content instead of 100 % width to keep positioning working.
  width: fit-content;

  .Toastify__toast {
    width: fit-content;

    .Toastify__toast-body {
      max-width: var(--toastify-toast-width);

      &.${toastWidthAutoClassName} {
        max-width: fit-content;
      }
    }

    &--default {
      ${baseToastStyle};
      background-color: ${({ theme }) => theme.colors.palette.pinkRose__500main};
      color: ${({ theme }) => theme.colors.textContrast};
    }

    &--info {
      ${baseToastStyle};
      background-color: ${({ theme }) => theme.colors.componentsAlertInfoBackground};
      color: ${({ theme }) => theme.colors.componentsAlertInfoColor};
    }

    &--success {
      ${baseToastStyle};
      background-color: ${({ theme }) => theme.colors.componentsAlertSuccessBackground};
      color: ${({ theme }) => theme.colors.componentsAlertSuccessColor};
    }

    &--warning {
      ${baseToastStyle};
      background-color: ${({ theme }) => theme.colors.componentsAlertWarningBackground};
      color: ${({ theme }) => theme.colors.componentsAlertWarningColor};
    }

    &--error {
      ${baseToastStyle};
      background-color: ${({ theme }) => theme.colors.componentsAlertErrorBackground};
      color: ${({ theme }) => theme.colors.componentsAlertErrorColor};
    }
  }
`;
